@for (certification of learnerCertifications; track certification) {
  <certification-display-list-item-slimmable
    [slimMode]="slimMode"
    [certification]="certification"
  ></certification-display-list-item-slimmable>
}
